import { Button, CheckCircle, Close, Heading, Paragraph, colors } from '../../..';
import { type PricingCardProps } from './types';
import {
  CardContainer,
  HeaderSection,
  FeaturesSection,
  FeatureItem,
  FeatureIconWrapper,
  PriceSection,
  PriceAmount,
  ButtonSection,
  ContactSalesSection,
} from './styles';

export const PricingCard = ({
  title,
  description,
  features,
  price,
  button,
  contactSalesText,
  highlighted = false,
  accentColor,
  'data-testid': dataTestId,
  headerContent,
}: PricingCardProps) => {
  const formatPrice = (amount: number, currency: string) => {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <CardContainer highlighted={highlighted} accentColor={accentColor} data-testid={dataTestId}>
      <HeaderSection highlighted={highlighted} accentColor={accentColor}>
        {headerContent}
        <Heading as="h4" variant="medium" color={highlighted ? colors.base.white : undefined}>
          {title}
        </Heading>
        <Paragraph variant="large" color={highlighted ? colors.base.white : colors.base.black}>
          {description}
        </Paragraph>
      </HeaderSection>

      <FeaturesSection>
        {features.map((feature) => (
          <FeatureItem key={feature.label} included={feature.included}>
            <FeatureIconWrapper>
              {feature.included ? (
                <CheckCircle
                  width="20px"
                  height="20px"
                  color={highlighted ? accentColor || colors.primary.blue : undefined}
                />
              ) : (
                <Close width="20px" height="20px" color={colors.monochrome.grey40} />
              )}
            </FeatureIconWrapper>
            <Paragraph variant="medium">{feature.label}</Paragraph>
          </FeatureItem>
        ))}
      </FeaturesSection>

      {contactSalesText ? (
        <ContactSalesSection>
          <Paragraph variant="large" color={colors.primary.grey}>
            {contactSalesText}
          </Paragraph>
        </ContactSalesSection>
      ) : (
        <>
          {price && (
            <PriceSection>
              <PriceAmount>
                <Heading as="h4" variant="xLarge">
                  {formatPrice(price.amount, price.currency)}
                </Heading>
                {price.period && (
                  <Paragraph variant="medium" color={colors.primary.grey}>
                    {price.period}
                  </Paragraph>
                )}
              </PriceAmount>
              {price.note && (
                <Paragraph variant="large" color={colors.primary.grey}>
                  {price.note}
                </Paragraph>
              )}
            </PriceSection>
          )}

          {button && (
            <ButtonSection>
              <Button
                variant={button.variant || 'primary'}
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.label}
              </Button>
            </ButtonSection>
          )}
        </>
      )}
    </CardContainer>
  );
};

export * from './types';
